import type { BramxCompareResponse } from './api';

export interface CompactDuelSide {
  livePoints: number;
  remaining: number;
  projected: number;
  winProbability: number;
}

export interface CompactDuelSummary {
  bram: CompactDuelSide;
  rival: CompactDuelSide;
  drawProbability: number;
}

export function compactDuelSummary(duel: BramxCompareResponse): CompactDuelSummary {
  return {
    bram: {
      livePoints: duel.entryA.provisionalPointsFromPublishedPicks,
      remaining: duel.entryA.expectedRemaining,
      projected: duel.entryA.projectedFinalPoints,
      winProbability: duel.simulation.gameweek.a.winProbability,
    },
    rival: {
      livePoints: duel.entryB.provisionalPointsFromPublishedPicks,
      remaining: duel.entryB.expectedRemaining,
      projected: duel.entryB.projectedFinalPoints,
      winProbability: duel.simulation.gameweek.b.winProbability,
    },
    drawProbability: duel.simulation.gameweek.drawProbability,
  };
}
